import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {concat, Observable, of, Subject} from "rxjs";
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from "rxjs/operators";
import {RegistrationManagersService} from "../../services/registration-managers.service";

@Component({
  standalone: false,
  selector: 'app-manager-combobox',
  templateUrl: './manager-combobox.component.pug',
  styleUrls: ['./manager-combobox.component.scss']
})
export class ManagerComboboxComponent implements OnInit {

  @Input()
  value: string;

  @Input()
  labelForId: string = "combobox_id";

  @Input()
  disabled: boolean = false;

  @Input()
  notAssignedLabel: string = "not_assigned";

  @Output()
  valueChange = new EventEmitter<string>();

  results$: Observable<any[]>;
  query$ = new Subject<string>();
  loading = false;
  debounce = 2000;

  constructor(private RMS: RegistrationManagersService) {
  }

  ngOnInit(): void {
    this.initSearch();
  }

  initSearch() {

    const notAssignedOption = {id: "not_assigned", label: this.notAssignedLabel} as SelectBoxEntity;
    this.results$ = concat(
      of([notAssignedOption]),
      this.query$.pipe(
        debounceTime(this.debounce),
        distinctUntilChanged(),
        tap(() => (this.loading = true)),
        switchMap((term) => {
          if (!term) {
            this.loading = false;
            return of([notAssignedOption]);
          }
          return this.RMS.getRegistrationManagers(term).pipe(
            map(items => items.map(item => ({ id: item, label: item }))),
            catchError(() => of([notAssignedOption])), // empty list on error
            tap(() => (this.loading = false))
          );
        })
      )
    );
  }

  onEntitySelected($event: any){
    this.valueChange.emit($event)
  }

  reset() {
    this.query$.next('');
    this.initSearch();
  }
}

export interface SelectBoxEntity {
  id: string;
  label: string;
}
